var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSendMsgIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.59 11.3326L4.08998 3.08263C3.96065 3.01795 3.81539 2.99204 3.67169 3.00801C3.52798 3.02397 3.39195 3.08114 3.27998 3.17263C3.17304 3.26225 3.09323 3.37992 3.04951 3.51241C3.00579 3.6449 2.99989 3.78697 3.03248 3.92263L5.25248 12.0001L3.00248 20.0551C2.9719 20.1684 2.96833 20.2873 2.99206 20.4022C3.01578 20.5171 3.06615 20.6249 3.1391 20.7168C3.21205 20.8087 3.30554 20.8822 3.41208 20.9315C3.51861 20.9807 3.6352 21.0042 3.75248 21.0001C3.86988 20.9994 3.98548 20.9712 4.08998 20.9176L20.59 12.6676C20.7128 12.6047 20.8159 12.5091 20.8879 12.3913C20.9599 12.2735 20.998 12.1382 20.998 12.0001C20.998 11.8621 20.9599 11.7267 20.8879 11.609C20.8159 11.4912 20.7128 11.3956 20.59 11.3326ZM4.91498 18.8326L6.57248 12.7501H13.5025V11.2501H6.57248L4.91498 5.16763L18.5725 12.0001L4.91498 18.8326Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendMsgIcon);
export default __webpack_public_path__ + "static/media/send-msg-icon.8e61e8a339e63de7ea12e260d0d2236c.svg";
export { ForwardRef as ReactComponent };